export function sendMessageToHost(message) {
    const parentWindow = window.parent;
    parentWindow.postMessage(message, '*');
}
